export const APP_NAME = 'Lotus Moonlight';

export const setTitle = (title) => {
    document.title = APP_NAME + " - " + title;
}